"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateListEditorSessions = void 0;
const Apiv2Client_1 = require("../Apiv2Client");
const ListEditorSessionsCommand_1 = require("../commands/ListEditorSessionsCommand");
const core_1 = require("@smithy/core");
exports.paginateListEditorSessions = (0, core_1.createPaginator)(Apiv2Client_1.Apiv2Client, ListEditorSessionsCommand_1.ListEditorSessionsCommand, "nextToken", "nextToken", "pageSize");
